export default "__VITE_ASSET__DqL1qBqM__"